$(document).ready(function() {
  // When the user clicks on <span> (x), close the modal
  document.getElementById("request_more-modal-close").onclick = function() {
    document.getElementById('requestMoreModal').style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == document.getElementById('requestMoreModal')) {
        document.getElementById('requestMoreModal').style.display = "none";
    }
  }
  
  // When the user clicks on <span> (x), close the modal
  document.getElementById("success-modal-close").onclick = function() {
    document.getElementById('successModal').style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == document.getElementById('successModal')) {
        document.getElementById('successModal').style.display = "none";
    }
  }
  
  // PULL URL QUERY AND ASSIGN
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // METAL
  var metal = "Yellow Gold";
  if (urlParams.has('metal')) {
    metal = urlParams.get('metal');
    document.getElementById("metal").value = metal;
    updateOptions();
  }

  // KARAT
  var karat = "10k Yellow Gold";
  if (urlParams.has('karat')) {
    karat = urlParams.get('karat');
    document.getElementById("karat").value = karat;
    updateOptions();
  }

  // SHAPE
  if (urlParams.has('shape')) {
    var shape = urlParams.get('shape');
    document.getElementById("shape").value = shape;
  }

  // WEIGHT
  var weight = "Standard";
  if (urlParams.has('weight')) {
    weight = urlParams.get('weight');
    document.getElementById("weight").value = weight;
    updateOptions();
  }

  // FINISH
  if (urlParams.has('finish')) {
    var finish = urlParams.get('finish');
    document.getElementById("finish").value = finish;
  }

  // SECOND FINISH
  if (urlParams.has('second_finish')) {
    var second_finish = urlParams.get('second_finish');
    document.getElementById("second_finish").value = second_finish;
  }

  // WIDTH
  if (urlParams.has('width')) {
    var width = urlParams.get('width');
    document.getElementById("width").value = width;
  }

  // RING SIZE
  if (urlParams.has('ring_size')) {
    var ringSize = urlParams.get('ring_size');
    document.getElementById("ring_size").value = ringSize;
  }
  
  updateAll("metal", metal, "none");
});

$(window).on('pageshow', function() {
  updateCustomImage();
});

function getURLQuery() {
  var urlQuery = "https://revolutionjewelry.com/pages/solid-gold-builder?";
  // METAL
  var metal = document.getElementById("metal").value;
  urlQuery = urlQuery.concat("metal=");
  urlQuery = urlQuery.concat(metal);
  
  // KARAT
  var karat = document.getElementById("karat").value;
  urlQuery = urlQuery.concat("&karat=");
  urlQuery = urlQuery.concat(karat);

  // SHAPE
  var shape = document.getElementById("shape").value;
  urlQuery = urlQuery.concat("&shape=");
  urlQuery = urlQuery.concat(shape);
  
  // WEIGHT
  var weight = document.getElementById("weight").value;
  urlQuery = urlQuery.concat("&weight=");
  urlQuery = urlQuery.concat(weight);

  // FINISH
  var finish = document.getElementById("finish").value;
  urlQuery = urlQuery.concat("&finish=");
  urlQuery = urlQuery.concat(finish);

  // SECOND FINISH
  var second_finish = document.getElementById("second_finish").value;
  urlQuery = urlQuery.concat("&second_finish=");
  urlQuery = urlQuery.concat(second_finish);

  // WIDTH
  var width = document.getElementById("width").value;
  urlQuery = urlQuery.concat("&width=");
  urlQuery = urlQuery.concat(width);

  // RING SIZE
  var ringSize = document.getElementById("ring_size").value;
  urlQuery = urlQuery.concat("&ring_size=");
  urlQuery = urlQuery.concat(ringSize);
  
  history.replaceState({}, '', urlQuery);
}

function updateAll(name, value) {
  if (typeof gtag == 'function') {
    gtag('event', 'select-image', {'action': 'click', 'label': name, 'value': value }); 
  }
  
  var selectedOption = document.getElementById(name).value;

  if (selectedOption == value && document.getElementById(name).innerHTML.includes('None') && name != 'accidental_damage_protection') {
    value = 'None';
  }
  
  updateSelectedImage(name, value);
  updateSelectedOption(name, value);
  updateSelectionField(name, value);
  updateOptions();
  updateCustomImage();
  updateAllSelections();

  checkInvoiceSubmit();
  updateRecommendations();
}

function checkInvoiceSubmit() {
  var notes = document.getElementById('notes');
  var priceEstimate = document.getElementById('price_estimate');
  var ringSize = document.getElementById('ring_size');

  if (priceEstimate != null && ringSize != null && priceEstimate.value != "Submit Request for Pricing" && ringSize.value != "Other") {
    $('#customInvoice').show();
    $('#requestMoreInfo').hide();
  } else {
    $('#customInvoice').hide();
    $('#requestMoreInfo').show();
  }
}

function updatePrice(src) {
  var origin = document.getElementById('origin').value;
  var size = document.getElementById('ring_size').value;

  var price = document.getElementById('price');
  var priceSelection = document.getElementById('price_selection');
  var priceEstimate = document.getElementById('price_estimate');
  var salePriceEstimate = document.getElementById('sale_price_estimate');
  var priceWithoutAddonsEstimate = document.getElementById('price_without_addons_estimate');
  var salePriceWithoutAddonsEstimate = document.getElementById('sale_price_without_addons_estimate');

  var isPrecious = "true";
  
  price.innerText = "---";
  priceSelection.innerText = "---";
  priceEstimate.value = "---";

  $.ajax({
    type: "POST",
    url: "https://custom.stonebrookjewelry.com/revo/precious/get_price.php",
    data: { ext: src, origin: origin, size: size, is_precious: isPrecious },
    success: function(returnedData){
      if (returnedData.price != "NAN") {
        if (returnedData.sale_price != returnedData.price) {
          if (Shopify.currency.active == "USD") {
            price.innerHTML = "Price: ".concat("<span class='money' style='color: #333;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.sale_price)).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceSelection.innerHTML = "<span class='money' style='color: #333;'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.sale_price)).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.sale_price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          } else {
            price.innerHTML = "Price: ".concat("<span class='money' style='color: #333;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.sale_price) * parseFloat(Shopify.currency.rate)))).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceSelection.innerHTML = "<span class='money' style='color: #333;'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.sale_price) * parseFloat(Shopify.currency.rate)))).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.sale_price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          }
        } else {
          if (Shopify.currency.active == "USD") {
            price.innerHTML = "Price: ".concat("<span class='money'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceSelection.innerHTML = "<span class='money'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          } else {
            price.innerHTML = "Price: ".concat("<span class='money'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceSelection.innerHTML = "<span class='money'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          }

          if (document.getElementById('waiting_to_submit').value == 'true') {
            document.getElementById('waiting_to_submit').value = 'false';
            checkPriceBeforeSubmit();
          }

          // window.currencyConverter._convertAll(Shopify.currency.active);
          // var newCurrency = document.getElementsByName('doubly-currencies');
          // if (newCurrency.length > 0) {
          //   newCurrency = newCurrency[0].value;
          //   DoublyGlobalCurrency.convertAll(newCurrency);
          // }
        }
        
        var src = "https://assets.lashbrookdesigns.com";
        src = src.concat(returnedData.image_src);
        if (src != "") {
          src = src.concat("&watermark=false");
          src = src.concat("&image_size=");
        
          if ($('#mobileCustomImg').first().is(':visible')) {
            document.getElementById("centerLoad").style.display = "block";
          }
          var smallImg = new Image();
          smallImg.src = src.concat("200");
          smallImg.crossOrigin = "Anonymous";
          smallImg.addEventListener("load", function() { drawSmallImage(smallImg); }, false);
        
          if ($('#leftMobileCustomImg').first().is(':visible')) {
            document.getElementById("leftLoad").style.display = "block";
          }
          var smallLeftImg = new Image();
          smallLeftImg.src = src.concat("200").replace("images/1","images/2");
          smallLeftImg.crossOrigin = "Anonymous";
          smallLeftImg.addEventListener("load", function() { drawSmallLeftImage(smallLeftImg); }, false);
        
          if ($('#rightMobileCustomImg').first().is(':visible')) {
            document.getElementById("rightLoad").style.display = "block";
          }
          var smallRightImg = new Image();
          smallRightImg.src = src.concat("200").replace("images/1","images/3");
          smallRightImg.crossOrigin = "Anonymous";
          smallRightImg.addEventListener("load", function() { drawSmallRightImage(smallRightImg); }, false);
        
          document.getElementById("topImgLoad").style.display = "block";
          var canvas = document.getElementById("topImg");
          var ctx = canvas.getContext("2d");
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, 700, 700);
          var largeImg = new Image();
          largeImg.src = src.concat("700");
          largeImg.crossOrigin = "Anonymous";
          largeImg.addEventListener("load", function() { drawLargeImage(largeImg); }, false);
        
          document.getElementById("imageURL").value = src.concat("700");

          var ringWidth = document.getElementById("width").value;
          ringWidth = ringWidth.replace("mm", "");
          ringWidth = "/".concat(ringWidth).concat("/");
          // 2mm
          var url2mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/2/");
          document.getElementById("2mm").src = url2mm;
          // 3mm
          var url3mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/3/");
          document.getElementById("3mm").src = url3mm;
          // 4mm
          var url4mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/4/");
          document.getElementById("4mm").src = url4mm;
          // 5mm
          var url5mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/5/");
          document.getElementById("5mm").src = url5mm;
          // 6mm
          var url6mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/6/");
          document.getElementById("6mm").src = url6mm;
          // 7mm
          var url7mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/7/");
          document.getElementById("7mm").src = url7mm;
          // 8mm
          var url8mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/8/");
          document.getElementById("8mm").src = url8mm;
          // 9mm
          var url9mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/9/");
          document.getElementById("9mm").src = url9mm;
          // 10mm
          var url10mm = src.concat("180").replace("images/1","images/2").replace(ringWidth, "/10/");
          document.getElementById("10mm").src = url10mm;

          var profiles = {"Domed": "D", "Flat": "F", "Beveled": "B-NS", "High Bevel": "HB", "Flat Grooved Edges": "FGE", "Concave Bevel": "CB", "Concave Center Round Edges": "REC", "Domed Bevel": "DB", "Domed Center Concave": "DC", "Domed Center Round": "DD", "Domed Milgrain Edges": "DMIL", "Domed Rounded Edges": "RED", "Domed Stepped Down Edges": "DGE", "Flat Double Stepped Edges": "F2S", "Flat Rounded Edges": "REF", "Flat Stepped Edges Milgrain": "FGEW2UMIL", "Flat Wide Grooved Edges": "FGEW", "High Bevel Milgrain": "HB2UMIL", "Stepped Bevel": "B-S", "Ultra Comfort": "UC", "Flat with Off Center Accent Groove": "F1.5OC", "Domed with Off Center Accent Groove": "D1.5OC", "Beveled with Center Accent Groove": "B11U", "Domed with Two Accent Grooves": "D2.5"};
          var shapeInput = document.getElementById("shape").value;
          var shape = profiles[shapeInput];
          var ringFinishes = {"Polish": "POLISH", "Satin": "SATIN", "Angle Satin": "ANGLESATIN", "Cross Satin": "CROSSSATIN", "Stone": "STONE", "Angle Stone": "ANGLESTONE", "Bead Blast": "BEAD", "Sand Blast": "SAND", "Hammer": "HAMMER", "Machine": "MACHINE", "Distressed": "DISTRESSED", "Treebark 1": "TREEBARK1", "Treebark 3": "TREEBARK3", "Treebark H": "TREEBARKH", "Rock": "ROCK", "Rock Polish": "ROCKPOLISH", "Stipple": "STIPPLE"};
          var ringFinish = document.getElementById("finish").value;
          var ringFinishCode = ringFinishes[ringFinish];
          var ringSecondFinish = document.getElementById("second_finish").value;
          var ringSecondFinishCode = ringFinishes[ringSecondFinish];
          var currentFinish = "";
          var finishPattern = "";
          var updatedFinish = "";

          if (shape == "DD" || shape == "DC" || shape == "REC" || shape == "REF") {
            currentFinish = "ring_finish=".concat("POLISH%2C".concat(ringFinishCode));
            finishPattern = "ring_finish=".concat("POLISH%2C".concat("firstFinish"));
          } else if (shape == "RED") {
            currentFinish = "ring_finish=".concat(ringFinishCode).concat("%2CPOLISH");
            finishPattern = "ring_finish=".concat("firstFinish").concat("%2CPOLISH");
          } else if (shape == "B11U") {
            currentFinish = "ring_finish=".concat("POLISH%2C".concat(ringFinishCode).concat('%2C').concat(ringSecondFinishCode));
            finishPattern = "ring_finish=".concat("POLISH%2C".concat("firstFinish").concat('%2C').concat("secondFinish"));
          } else if (shape == "CB" || shape == "B" || shape == "F1.5OC" || shape == "D1.5OC" || shape == "D2.5" || shape == "HB" || shape == "FGE" || shape == "DB" || shape == "DGE" || shape == "FGEW2UMIL" || shape == "FGEW" || shape == "HB2UMIL" || shape == "B-S" || shape == "F2S") {
            currentFinish = "ring_finish=".concat(ringFinishCode).concat("%2C").concat(ringSecondFinishCode);
            finishPattern = "ring_finish=".concat("firstFinish").concat("%2C").concat("secondFinish");
          } else {
            currentFinish = "ring_finish=".concat(ringFinishCode);
            finishPattern = "ring_finish=".concat("firstFinish");
          }

          // Polish
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "POLISH").replace("secondFinish", ringSecondFinishCode);
          var urlPolish = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("polish").src = urlPolish;
        
          // Satin
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "SATIN").replace("secondFinish", ringSecondFinishCode);
          var urlSatin = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("satin").src = urlSatin;
        
          // Angle Satin
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "ANGLESATIN").replace("secondFinish", ringSecondFinishCode);
          var urlAngleSatin = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("anglesatin").src = urlAngleSatin;

          // Cross Satin
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "CROSSSATIN").replace("secondFinish", ringSecondFinishCode);
          var urlCrossSatin = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("crosssatin").src = urlCrossSatin;

          // Stone
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "STONE").replace("secondFinish", ringSecondFinishCode);
          var urlStone = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("stone").src = urlStone;

          // Angle Stone
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "ANGLESTONE").replace("secondFinish", ringSecondFinishCode);
          var urlAngleStone = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("anglestone").src = urlAngleStone;

          // Bead Blast
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "BEAD").replace("secondFinish", ringSecondFinishCode);
          var urlBead = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("bead").src = urlBead;

          // Sand Blast
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "SAND").replace("secondFinish", ringSecondFinishCode);
          var urlSand = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("sand").src = urlSand;

          // Hammer
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "HAMMER").replace("secondFinish", ringSecondFinishCode);
          var urlHammer = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("hammer").src = urlHammer;

          // Machine
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "MACHINE").replace("secondFinish", ringSecondFinishCode);
          var urlMachine = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("machine").src = urlMachine;

          // Distressed
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "DISTRESSED").replace("secondFinish", ringSecondFinishCode);
          var urlDistressed = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("distressed").src = urlDistressed;

          // Treebark 1
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "TREEBARK1").replace("secondFinish", ringSecondFinishCode);
          var urlTreebark1 = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("treebark1").src = urlTreebark1;

          // Treebark 3
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "TREEBARK3").replace("secondFinish", ringSecondFinishCode);
          var urlTreebark3 = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("treebark3").src = urlTreebark3;

          // Treebark H
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "TREEBARKH").replace("secondFinish", ringSecondFinishCode);
          var urlTreebarkH = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("treebarkh").src = urlTreebarkH;

          // Rock
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "ROCK").replace("secondFinish", ringSecondFinishCode);
          var urlRock = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("rock").src = urlRock;

          // Rock Polish
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "ROCKPOLISH").replace("secondFinish", ringSecondFinishCode);
          var urlRockPolish = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("rockpolish").src = urlRockPolish;

          // Stipple
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("firstFinish", "STIPPLE").replace("secondFinish", ringSecondFinishCode);
          var urlStipple = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("stipple").src = urlStipple;
          
          // Secondary Polish
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "POLISH").replace("firstFinish", ringFinishCode);
          var urlPolish = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondpolish").src = urlPolish;
        
          // Secondary Satin
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "SATIN").replace("firstFinish", ringFinishCode);
          var urlSatin = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondsatin").src = urlSatin;
        
          // Secondary Angle Satin
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "ANGLESATIN").replace("firstFinish", ringFinishCode);
          var urlAngleSatin = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondanglesatin").src = urlAngleSatin;

          // Secondary Cross Satin
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "CROSSSATIN").replace("firstFinish", ringFinishCode);
          var urlCrossSatin = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondcrosssatin").src = urlCrossSatin;

          // Secondary Stone
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "STONE").replace("firstFinish", ringFinishCode);
          var urlStone = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondstone").src = urlStone;

          // Secondary Angle Stone
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "ANGLESTONE").replace("firstFinish", ringFinishCode);
          var urlAngleStone = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondanglestone").src = urlAngleStone;

          // Secondary Bead Blast
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "BEAD").replace("firstFinish", ringFinishCode);
          var urlBead = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondbead").src = urlBead;

          // Secondary Sand Blast
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "SAND").replace("firstFinish", ringFinishCode);
          var urlSand = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondsand").src = urlSand;

          // Secondary Hammer
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "HAMMER").replace("firstFinish", ringFinishCode);
          var urlHammer = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondhammer").src = urlHammer;

          // Secondary Machine
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "MACHINE").replace("firstFinish", ringFinishCode);
          var urlMachine = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondmachine").src = urlMachine;

          // Secondary Distressed
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "DISTRESSED").replace("firstFinish", ringFinishCode);
          var urlDistressed = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("seconddistressed").src = urlDistressed;

          // Secondary Treebark 1
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "TREEBARK1").replace("firstFinish", ringFinishCode);
          var urlTreebark1 = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondtreebark1").src = urlTreebark1;

          // Secondary Treebark 3
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "TREEBARK3").replace("firstFinish", ringFinishCode);
          var urlTreebark3 = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondtreebark3").src = urlTreebark3;

          // Secondary Treebark H
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "TREEBARKH").replace("firstFinish", ringFinishCode);
          var urlTreebarkH = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondtreebarkh").src = urlTreebarkH;

          // Secondary Rock
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "ROCK").replace("firstFinish", ringFinishCode);
          var urlRock = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondrock").src = urlRock;

          // Secondary Rock Polish
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "ROCKPOLISH").replace("firstFinish", ringFinishCode);
          var urlRockPolish = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondrockpolish").src = urlRockPolish;

          // Secondary Stipple
          updatedFinish = finishPattern;
          updatedFinish = updatedFinish.replace("secondFinish", "STIPPLE").replace("firstFinish", ringFinishCode);
          var urlStipple = src.concat("180").replace("images/1","images/2").replace(currentFinish, updatedFinish);
          document.getElementById("secondstipple").src = urlStipple;
        
        }
      } else {
        price.innerText = "Submit Request for Pricing";
        priceSelection.innerText = "Submit Request for Pricing";
        priceEstimate.value = "Submit Request for Pricing";
        salePriceEstimate.value = "Submit Request for Pricing";
        priceWithoutAddonsEstimate.value = "Submit Request for Pricing";
        salePriceWithoutAddonsEstimate.value = "Submit Request for Pricing";
      }
      checkInvoiceSubmit();
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      price.innerText = "Submit Request for Pricing";
      priceSelection.innerText = "Submit Request for Pricing";
      priceEstimate.value = "Submit Request for Pricing";
      salePriceEstimate.value = "Submit Request for Pricing";
      priceWithoutAddonsEstimate.value = "Submit Request for Pricing";
      salePriceWithoutAddonsEstimate.value = "Submit Request for Pricing";

      console.log("XMLHttpRequest: ");
      console.log(XMLHttpRequest);
      console.log("textStatus: ");
      console.log(textStatus);
      console.log("errorThrown: ");
      console.log(errorThrown);
      checkInvoiceSubmit();
    }
  });
}

function updateAllSelections() {
  updateSelectedOption("metal", document.getElementById("metal").value);
  updateSelectedOption("karat", document.getElementById("karat").value);
  updateSelectedOption("shape", document.getElementById("shape").value);
  updateSelectedOption("weight", document.getElementById("weight").value);
  updateSelectedOption("finish", document.getElementById("finish").value);
  updateSelectedOption("second_finish", document.getElementById("second_finish").value);
  updateSelectedOption("width", document.getElementById("width").value);
  
  updateSelectedImage("metal", document.getElementById("metal").value);
  updateSelectedImage("karat", document.getElementById("karat").value);
  updateSelectedImage("shape", document.getElementById("shape").value);
  updateSelectedImage("weight", document.getElementById("weight").value);
  updateSelectedImage("finish", document.getElementById("finish").value);
  updateSelectedImage("second_finish", document.getElementById("second_finish").value);
  updateSelectedImage("width", document.getElementById("width").value);
  
  updateSelectionField("karat", document.getElementById("karat").value);
  updateSelectionField("shape", document.getElementById("shape").value);
  updateSelectionField("weight", document.getElementById("weight").value);
  updateSelectionField("finish", document.getElementById("finish").value);
  updateSelectedImage("second_finish", document.getElementById("second_finish").value);
  updateSelectionField("width", document.getElementById("width").value);
  
  updateSelectionField("notes", document.getElementById("notes").value);
}

function updateSelectedOption(name, value) {
  if (name == "design_pattern") {
    name = "design";
  }
  if (name == "secondary_design_pattern") {
    name = "secondary_design";
  }
  var selector = '[name="'.concat(name).concat('"]');
  var selects = $(selector);
  if (selects.length > 0) {
    var select = selects[0];
    var options = select.options;
    for (var opt, j = 0; opt = options[j]; j++) {
      if (opt.value == value) {
        select.selectedIndex = j;
        break;
      }
    }
  }
}

function updateSelectedImage(name, value) {
  var classSelector = '.'.concat(name);
  var imageContainers = $(classSelector);
  if (imageContainers.length > 0) {
    for (var i = 0; i < imageContainers.length; i++) {
      var dataValue = imageContainers[i].getAttribute("data-value");
      if (dataValue == value) {
        imageContainers[i].style.border = "2px solid #333";
        imageContainers[i].style.padding = "3px";
      } else if (dataValue != null && dataValue.toLowerCase() != name) {
        imageContainers[i].style.border = "transparent";
        imageContainers[i].style.padding = "5px";
      }
    }
  }
}

function updateSelectionField(name, value) {
  var id = '#'.concat(name).concat("_selection_container");
  var elements = $(id);
  var elementId = name.concat("_selection");
  if (document.getElementById(elementId) != null) {
    var element = document.getElementById(elementId);
    if (value == "") {
      element.innerHTML = "None Selected";
      if (name != "metal" && name != "finish" && name != "seoncd_finish" && name != "width" && name != "shape") {
        elements.hide();
      }
    } else {
      element.innerHTML = value;
      elements.show();
    }
  }
}

function updateOptions() {
  // Metal - Karat - Shape - Finish
  var ringMetal = document.getElementById("metal").value;

  var shapes = ["Beveled","Concave Bevel","Concave Center Round Edges","Domed","Domed Bevel","Domed Center Concave","Domed Center Round","Domed Milgrain Edges","Domed Rounded Edges","Domed Stepped Down Edges","Flat","Flat Double Stepped Edges","Flat Grooved Edges","Flat Rounded Edges","Flat Stepped Edges Milgrain","Flat Wide Grooved Edges","High Bevel","High Bevel Milgrain","Stepped Bevel","Ultra Comfort","Flat with Off Center Accent Groove","Domed with Off Center Accent Groove","Beveled with Center Accent Groove","Domed with Two Accent Grooves"];
  var finishes = ["Angle Satin","Angle Stone","Bead Blast","Cross Satin","Distressed","Hammer","Machine","Polish","Rock","Rock Polish","Sand Blast","Satin","Stipple","Stone","Treebark 1","Treebark 3","Treebark H"];
  var milgrainFinishes = ["Angle Satin","Bead Blast","Hammer","Machine","Polish","Polish Kuro-Ti","Sand Blast","Satin","Satin Etched Kuro-Ti","Stipple","Stone","Treebark 3","Treebark H"];
  var bevelFinishes = ["Acid Damascus","Angle Satin","Angle Stone","Bead Blast","Bead Blast Damascus","Bead Blast Etched Superconductor","Bead Blast Kuro Damascus","Bead Blast Superconductor","Cross Satin","Distressed","Hammer","Machine","Polish","Polish Damascus","Polish Kuro Damascus","Polish Kuro-Ti","Polish Etched Superconductor","Polish Superconductor","Sand Blast","Satin","Satin Etched Kuro-Ti","Satin Etched Superconductor","Satin Superconductor","Stone","Treebark 1","Treebark 3","Treebark H","Tumble Kuro Damascus"];
  var concaveFinishes = ["Acid Damascus","Bead Blast Damascus","Bead Blast Etched Superconductor","Bead Blast Kuro Damascus","Bead Blast Superconductor","Hammer","Machine","Polish","Polish Damascus","Polish Kuro Damascus","Polish Kuro-Ti","Polish Etched Superconductor","Polish Superconductor","Sand Blast","Satin","Satin Etched Kuro-Ti","Satin Etched Superconductor","Satin Superconductor","Treebark H","Tumble Kuro Damascus"];
  var domedBevelFinishes = ["Acid Damascus","Angle Satin","Angle Stone","Bead Blast","Bead Blast Damascus","Bead Blast Kuro Damascus","Distressed","Hammer","Machine","Polish","Polish Damascus","Polish Kuro Damascus","Polish Kuro-Ti","Sand Blast","Satin","Satin Etched Kuro-Ti","Stone","Treebark 1","Treebark H","Tumble Kuro Damascus"];
  var roundEdgeFinishes = ["Acid Damascus","Bead Blast","Bead Blast Damascus","Bead Blast Kuro Damascus","Hammer","Machine","Polish","Polish Damascus","Polish Kuro Damascus","Polish Kuro-Ti","Sand Blast","Satin","Satin Etched Kuro-Ti","Stipple","Stone","Treebark 3","Treebark H","Tumble Kuro Damascus"];
  var lessThanThreeMMFinishes = ["Acid Damascus","Angle Satin","Bead Blast","Bead Blast Damascus","Bead Blast Etched Superconductor","Bead Blast Kuro Damascus","Bead Blast Superconductor","Cross Satin","Cross Satin Black","Cross Satin Silver","Distressed","Hammer","Machine","Polish","Polish Damascus","Polish Etched Superconductor","Polish Kuro Damascus","Polish Kuro-Ti","Polish Superconductor","Sand Blast","Satin","Satin Etched Kuro-Ti","Satin Etched Superconductor","Satin Superconductor","Stone","Tumble Kuro Damascus"];

  // Karat
  var karats = [];
  
  if (ringMetal == "Platinum") {
    karats = ["Platinum"];
    $("#karat_container").hide();
  } else if (ringMetal == "Rose Gold") {
    karats = ["14k Rose Gold", "18k Rose Gold"];
    $("#karat_container").show();
  } else if (ringMetal == "White Gold") {
    karats = ["10k White Gold", "14k White Gold", "18k White Gold"];
    $("#karat_container").show();
  } else if (ringMetal == "Yellow Gold") {
    karats = ["10k Yellow Gold", "14k Yellow Gold", "18k Yellow Gold", "22k Yellow Gold"];
    $("#karat_container").show();
  }
  updateSelectOptions("karat", karats);
  updateSelectImages("karat", karats);
  
  // Shape
  $(".shape").show();

  if (ringMetal == "Yellow Gold") {
    $('#yellow-gold-shape').show();
    $('#rose-gold-shape').hide();
    $('#white-gold-shape').hide();
  } else if (ringMetal == "Rose Gold") {
    $('#yellow-gold-shape').hide();
    $('#rose-gold-shape').show();
    $('#white-gold-shape').hide();
  } else if (ringMetal == "White Gold" || ringMetal == "Platinum") {
    $('#yellow-gold-shape').hide();
    $('#rose-gold-shape').hide();
    $('#white-gold-shape').show();
  }

  updateSelectOptions("shape", shapes);

  // Weight
  var ringShape = document.getElementById("shape").value;
  var allWeights = ["Premium", "Standard", "Light"];
  var noLight = ["Premium", "Standard"];
  var allWeightShapes = ["Domed", "Beveled", "Flat", "Flat Grooved Edges", "Domed Rounded Edges", "Concave Center Round Edges", "Domed Milgrain Edges", "Flat Stepped Edges Milgrain", "Flat Wide Grooved Edges", "Domed with Off Center Accent Groove", "Beveled with Center Accent Groove", "Domed with Two Accent Grooves", "Ultra Comfort", "Domed Center Round", "Domed Center Concave"];
  var noLightShapes = ["High Bevel", "Concave Bevel", "Domed Bevel", "Domed Stepped Down Edges", "Float Rounded Edges", "High Bevel Milgrain", "Stepped Bevel", "Flat with Off Center Accent Groove", "Flat Double Stepped Edges"];

  var availableWeights = allWeights;
  if (noLightShapes.includes(ringShape)) {
    availableWeights = noLight;
  }
  updateSelectOptions("weight", availableWeights);
  updateSelectImages("weight", availableWeights);
    
  // Width
  var ringWidth = document.getElementById("width").value;
  var ringFinish = document.getElementById("finish").value;
  var width210 = ["2mm","3mm","4mm","5mm","6mm","7mm","8mm","9mm","10mm"];
  var width310 = ["3mm","4mm","5mm","6mm","7mm","8mm","9mm","10mm"];
  var width410 = ["4mm","5mm","6mm","7mm","8mm","9mm","10mm"];
  var width510 = ["5mm","6mm","7mm","8mm","9mm","10mm"];
  var width610 = ["6mm","7mm","8mm","9mm","10mm"];

  if (ringShape == "Domed" || ringShape == "Flat" || ringShape == "Ultra Comfort") {
    updateSelectOptions("width", width210);
    updateSelectImages("width", width210);
  } else if (ringShape == "Concave Bevel") {
    updateSelectOptions("width", width310);
    updateSelectImages("width", width310);
  } else if (ringShape == "Domed Center Concave" || ringShape == "Domed Center Round" || ringShape == "Domed Milgrain Edges" || ringShape == "Beveled" || ringShape == "Flat with Off Center Accent Groove" || ringShape == "Domed with Off Center Accent Groove" || ringShape == "Domed with Two Accent Grooves") {
    updateSelectOptions("width", width410);
    updateSelectImages("width", width410);
  } else if (ringShape == "High Bevel" || ringShape == "Flat Grooved Edges" || ringShape == "Domed Bevel" || ringShape == "Domed Rounded Edges" || ringShape == "Domed Stepped Down Edges" || ringShape == "Flat Double Stepped Edges" || ringShape == "Flat Rounded Edges" || ringShape == "Flat Stepped Edges Milgrain" || ringShape == "Flat Wide Grooved Edges" || ringShape == "Stepped Bevel" || ringShape == "High Bevel Milgrain" || ringShape == "Beveled with Center Accent groove") {
    updateSelectOptions("width", width510);
    updateSelectImages("width", width510);
  } else if (ringShape == "Concave Center Round Edges") {
    updateSelectOptions("width", width610);
    updateSelectImages("width", width610);
  }

  // Finish
  var availableFinishes = [];
  var widths = {"2mm": 2, "3mm": 3, "4mm": 4, "5mm": 5, "6mm": 6, "7mm": 7, "8mm": 8, "9mm": 9, "10mm": 10};

  availableFinishes = finishes;
  
  // Finish by Shape
  if (ringShape == "Domed Milgrain Edges" || ringShape == "High Bevel Milgrain") {
    availableFinishes = joinArrays(availableFinishes, milgrainFinishes);
  }
  if (ringShape == "Beveled" || ringShape == "High Bevel") {
    availableFinishes = joinArrays(availableFinishes, bevelFinishes);
  }
  if (ringShape == "Domed Bevel") {
    availableFinishes = joinArrays(availableFinishes, domedBevelFinishes);
  }
  if (ringShape == "Concave Bevel" || ringShape == "Concave Center Round Edges") {
    availableFinishes = joinArrays(availableFinishes, concaveFinishes);
  }
  if (ringShape == "Domed Rounded Edges") {
    availableFinishes = joinArrays(availableFinishes, roundEdgeFinishes);
  }
  if (ringShape == "Ultra Comfort") {
    availableFinishes = ["Polish"];
  }
  
  // Finish by Remaining Ring Width
  ringWidth = document.getElementById("width").value;
  
  // If current finish not in finishes
  if (!availableFinishes.includes(ringFinish)) {
    showAlertModal();
  }
  
  // Update Finishes
  updateSelectOptions("finish", availableFinishes);
  updateSelectImages("finish", availableFinishes);

  // Second Finish
  var availableSecondaryFinishes = [];

  if (ringShape == "Domed" || ringShape == "Flat" || ringShape == "Ultra Comfotrt" || ringShape == "Domed Milgrain Edges") {
    availableSecondaryFinishes = []
  } else if (ringShape == "Domed with Two Accent Grooves") {
    availableSecondaryFinishes = finishes;
  } else if (ringShape == "Concave Bevel" || ringShape == "Beveled" || ringShape == "Flat with Off Center Accent Groove" || ringShape == "Domed with Off Center Accent Groove" || ringShape == "High Bevel" || ringShape == "Flat Grooved Edges" || ringShape == "Domed Bevel" || ringShape == "Domed Stepped Down Edges" || ringShape == "Flat Stepped Edges Milgrain" || ringShape == "Flat Wide Grooved Edges" || ringShape == "High Bevel Milgrain" || ringShape == "Stepped Bevel" || ringShape == "Flat Double Stepped Edges" || ringShape == "Beveled with Center Accent Groove") {
    availableSecondaryFinishes = ["Polish", "Satin", "Bead Blast", "Sand Blast"];
  } else if (ringShape == "Domed Center Round" || ringShape == "Domed Center Concave" || ringShape == "Concave Center Round Edges" || ringShape == "Domed Rounded Edges" || ringShape == "Flat Rounded Edges") {
    availableSecondaryFinishes = ["Polish"];
  }
  
  // Update Secondary Finishes
  updateSelectOptions("second_finish", availableSecondaryFinishes);
  updateSelectImages("second_finish", availableSecondaryFinishes);

  if (availableSecondaryFinishes.length == 0) {
    $('#second_finish_container').hide();
  } else {
    $('#second_finish_container').show();
  }

  // Ring size
  var standardSizes = ["Send Ring Sizers","3","3.25","3.5","3.75","4","4.25","4.5","4.75","5","5.25","5.5","5.75","6","6.25","6.5","6.75","7","7.25","7.5","7.75","8","8.25","8.5","8.75","9","9.25","9.5","9.75","10","10.25","10.5","10.75","11","11.25","11.5","11.75","12","12.25","12.5","12.75","13","13.25","13.5","13.75","14","14.25","14.5","14.75","15","15.25","15.5","15.75","16","16.25","16.5","16.75","17","17.25","17.5","17.75","18","18.25","18.5","18.75","19","19.25","19.5","19.75","20","20.25","20.5","20.75","21","21.25","21.5","21.75","22","22.25","22.5","22.75","23","23.25","23.5","23.75","24"];
  
  updateSelectOptions("ring_size", standardSizes);
}

function joinArrays(array1, array2) {
  var joinArray = [];
  var i;
  for (i = 0; i < array1.length; i++) {
    if (array2.includes(array1[i])) {
      joinArray.push(array1[i]);
    }
  }
  return joinArray;
}

function updateSelectOptions(selectId, newOptions) {
  var oldValue = document.getElementById(selectId).value;
  var id = '#'.concat(selectId);
  /* Remove all options from the select list */
  $(id).empty();

  /* Insert the new ones from the array above */
  var i;
  for (i = 0; i < newOptions.length; i++) {
    var select  = document.getElementById(selectId);
    var option = document.createElement("option");
    if (newOptions[i] == "Other" && selectId == "ring_size") {
      option.text = "Other (specify in notes)";
    } else {
      option.text = newOptions[i];
    }
    if (newOptions[i].includes("Select") || (newOptions[i] == "None" && selectId != "finish")) {
      option.value = "";
    } else {
      option.value = newOptions[i];
    }
    select.add(option);
  }
  if (newOptions.includes(oldValue)) {
    document.getElementById(selectId).value = oldValue;
  } else if (selectId == "finish" && newOptions.includes("Polish")) {
    document.getElementById(selectId).value = "Polish";
  } else {
    document.getElementById(selectId).selectedIndex = 0;
  }
}

function updateSelectImages(selectId, newOptions) {
  // Hide all images
  var sectionName = '.'.concat(selectId);
  $(sectionName).hide();

  // Show available images
  var i;
  for (i = 0; i < newOptions.length; i++) {
    var optionName = sectionName.concat('.').concat(newOptions[i]).replace(/ /g,"_").toLowerCase();
    $(optionName).show();
  }
}

function updateCustomImage() {
  var profiles = {"Domed": "D", "Flat": "F", "Beveled": "B-NS", "High Bevel": "HB", "Flat Grooved Edges": "FGE", "Concave Bevel": "CB", "Concave Center Round Edges": "REC", "Domed Bevel": "DB", "Domed Center Concave": "DC", "Domed Center Round": "DD", "Domed Milgrain Edges": "DMIL", "Domed Rounded Edges": "RED", "Domed Stepped Down Edges": "DGE", "Flat Double Stepped Edges": "F2S", "Flat Rounded Edges": "REF", "Flat Stepped Edges Milgrain": "FGEW2UMIL", "Flat Wide Grooved Edges": "FGEW", "High Bevel Milgrain": "HB2UMIL", "Stepped Bevel": "B-S", "Ultra Comfort": "UC", "Flat with Off Center Accent Groove": "F1.5OC", "Domed with Off Center Accent Groove": "D1.5OC", "Beveled with Center Accent Groove": "B11U", "Domed with Two Accent Grooves": "D2.5"};

  var widths = {"2mm": "2", "3mm": "3", "4mm": "4", "5mm": "5", "6mm": "6", "7mm": "7", "8mm": "8", "9mm": "9", "10mm": "10"};

  var ringMaterials = {"Titanium": "T", "Cobalt Chrome": "CC", "Inconel": "CC", "Black Titanium": "Z", "Black Zirconium": "Z", "Tantalum": "TA", "Darkened Tantalum": "NTA", "Damascus Steel": "D", "Zebra Damascus Steel": "D-ZEBRA", "Flattwist Damascus Steel": "D-FLATTWIST", "Basketweave Damascus Steel": "D-BASKETWEAVE", "Tiger Damascus Steel": "D-TIGER", "Kuro Damascus Steel": "D-WOODGRAIN", "Marble Damascus Steel": "D-MARBLE", "Sunset Damascus Steel": "D-SUNSET", "Tightweave Damascus Steel": "D-TIGHTWEAVE", "Kinetic Damascus Steel": "D-KINETIC", "Scale Damascus Steel": "D-SCALE", "10k Yellow Gold": "10KY", "14k Yellow Gold": "14KY", "18k Yellow Gold": "18KY", "22k Yellow Gold": "22KY", "10k White Gold": "10KW", "14k White Gold": "14KW", "18k White Gold": "18KW", "14k Rose Gold": "14KR", "18k Rose Gold": "18KR", "Palladium": "PALL", "Platinum": "PLAT", "Palladium Silver": "CC", "Kuro-Ti": "TD", "Superconductor": "SC", "Darkened Superconductor": "NSC", "Meteorite" : "MET", "Forged Carbon Fiber" : "FORGEDCF"};

  var ringWeights = {"Premium": "P", "Standard": "IS", "Light": "L"};
  
  var ringFinishes = {"None": "", "Polish": "POLISH", "Polish Damascus": "POLISH", "Polish Kuro Damascus": "POLISH", "Polish Kuro-Ti": "POLISH", "Satin": "SATIN", "Satin Etched Kuro-Ti": "SATINETCHED", "Angle Satin": "ANGLESATIN", "Cross Satin": "CROSSSATIN", "Cross Satin Black": "CROSSSATINBLACK", "Cross Satin Silver": "CROSSSATINSILVER", "Stone": "STONE", "Angle Stone": "ANGLESTONE", "Bead Blast": "BEAD", "Bead Blast Damascus": "BEAD", "Bead Blast Kuro Damascus": "BEAD", "Sand Blast": "SAND", "Hammer": "HAMMER", "Machine": "MACHINE", "Distressed": "DISTRESSED", "Treebark 1": "TREEBARK1", "Treebark 3": "TREEBARK3", "Treebark H": "TREEBARKH", "Rock": "ROCK", "Rock Polish": "ROCKPOLISH", "Stipple": "STIPPLE", "Acid": "ACID", "Acid Damascus": "ACID", "Tumble": "ACID", "Tumble Kuro Damascus": "ACID", "Polish Superconductor": "POLISH", "Satin Superconductor": "SATIN", "Bead Blast Superconductor": "BEAD", "Polish Etched Superconductor": "POLISHETCHED", "Satin Etched Superconductor": "SATINETCHED", "Bead Blast Etched Superconductor": "BEADETCHED"};
  
  var materialInput = document.getElementById("karat");
  var material = ringMaterials[materialInput.value];
  var shapeInput = document.getElementById("shape");
  var shape = profiles[shapeInput.value];
  var weightInput = document.getElementById("weight");
  var weight = ringWeights[weightInput.value];
  var finishInput = document.getElementById("finish");
  var finish = ringFinishes[finishInput.value];
  var secondFinishInput = document.getElementById("second_finish");
  var secondFinish = ringFinishes[secondFinishInput.value];
  var widthInput = document.getElementById("width");
  var width = widths[widthInput.value];

  var src = "/rings/profiles/";
  // var src = "https://assets.lashbrookdesigns.com/rings/profiles/";
  // var src = "https://api.lashbrookdesigns.com/api/v1";
  src = src.concat(shape);
  src = src.concat("/widths/");
  src = src.concat(width);
  src = src.concat("/ring_materials/");
  src = src.concat(material);
  src = src.concat("?ring_finish=");
  if (shape == "DD" || shape == "DC" || shape == "REC" || shape == "REF") {
    src = src.concat("POLISH%2C").concat(finish);
  } else if (shape == "RED") {
    src = src.concat(finish).concat("%2CPOLISH");
  } else if (shape == "B11U") {
    src = src.concat("POLISH%2C").concat(finish).concat('%2C').concat(secondFinish);
  } else if (shape == "CB" || shape == "B" || shape == "F1.5OC" || shape == "D1.5OC" || shape == "D2.5" || shape == "HB" || shape == "FGE" || shape == "DB" || shape == "DGE" || shape == "FGEW2UMIL" || shape == "FGEW" || shape == "HB2UMIL" || shape == "B-S" || shape == "F2S") {
    src = src.concat(finish).concat("%2C").concat(secondFinish);
  } else {
    src = src.concat(finish);
  }
  src = src.concat("&finish_type=FS");
  src = src.concat("&weight=");
  src = src.concat(weight);

  var ringSize = document.getElementById("ring_size").value;
  src = src.concat("&size=");
  if (ringSize != null && ringSize != 'Send Ring Sizers') {
    src = src.concat(ringSize);
  } else {
    src = src.concat("10");
  }
  src = src.concat("&feature_group=N");
  // src = src.concat("&watermark=false");

  // console.log("SRC:");
  // console.log(src);

  if ($('#mobileCustomImg').first().is(':visible')) {
    document.getElementById("centerLoad").style.display = "block";
  }
  
  if ($('#leftMobileCustomImg').first().is(':visible')) {
    document.getElementById("leftLoad").style.display = "block";
  }
  
  if ($('#rightMobileCustomImg').first().is(':visible')) {
    document.getElementById("rightLoad").style.display = "block";
  }
  
  document.getElementById("topImgLoad").style.display = "block";
  
  updatePrice(src);
  getURLQuery();
}

function drawSmallImage(img) {
  document.getElementById("centerLoad").style.display = "none";

  var canvas = document.getElementById("mobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawSmallLeftImage(img) {
  document.getElementById("leftLoad").style.display = "none";

  var canvas = document.getElementById("leftMobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawSmallRightImage(img) {
  document.getElementById("rightLoad").style.display = "none";

  var canvas = document.getElementById("rightMobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawLargeImage(img) {
  document.getElementById("topImgLoad").style.display = "none";

  var canvas = document.getElementById("topImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeCenterImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "block";

  var canvas = document.getElementById("modalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeLeftImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("leftModalCustomImg").style.display = "block";

  var canvas = document.getElementById("leftModalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeRightImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "block";

  var canvas = document.getElementById("rightModalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function showModal(image) {
  // Get the modal
  var modal = document.getElementById("imageModal");
  var src = document.getElementById("imageURL").value;

  // gtag('event', 'show-modal', {'action': 'click', 'label': image }); 

  document.getElementById("leftModalCustomImg").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "none";

  modal.style.display = "block";
  if(image == 'left') {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeLeftImg = new Image();
    src = src.replace("images/1","images/2");
    largeLeftImg.src = src;
    largeLeftImg.crossOrigin = "Anonymous";
    largeLeftImg.addEventListener("load", function() { drawLargeLeftImage(largeLeftImg); }, false);
  } else if (image == 'right') {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeRightImg = new Image();
    src = src.replace("images/1","images/3");
    largeRightImg.src = src;
    largeRightImg.crossOrigin = "Anonymous";
    largeRightImg.addEventListener("load", function() { drawLargeRightImage(largeRightImg); }, false);
  } else {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeImg = new Image();
    largeImg.src = src;
    largeImg.crossOrigin = "Anonymous";
    largeImg.addEventListener("load", function() { drawLargeCenterImage(largeImg); }, false);
  }
}

function hideModal() {
  var modal = document.getElementById("imageModal");

  modal.style.display = "none";
  document.getElementById("leftModalCustomImg").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "none";
}

function showAlertModal() {
  var modal = document.getElementById("alertModal");
  modal.style.display = "block";
  setTimeout(function(){ document.getElementById("alertModal").style.display = "none"; }, 5000);
}

function sticky_relocate() {
  var stickyModalSize = 197.2;
  var headerSize = 100;
  var window_top = Math.round($(window).scrollTop());
  var div_top = $('.pattern-heading').eq(0).offset().top;
  if (window_top > (div_top - stickyModalSize)) {
    document.getElementById("leftMobileCustomImg").style.display = "block";
    document.getElementById("leftIconContainer").style.display = "block";
    document.getElementById("leftMagIcon").style.display = "block";
    document.getElementById("mobileCustomImg").style.display = "block";
    document.getElementById("iconContainer").style.display = "block";
    document.getElementById("magIcon").style.display = "block";
    document.getElementById("rightMobileCustomImg").style.display = "block";
    document.getElementById("rightIconContainer").style.display = "block";
    document.getElementById("rightMagIcon").style.display = "block";
    document.getElementById("mobileHeader").style.display = "block";
    document.getElementById("price").style.display = "block";
    document.getElementById("currency_message").style.display = "block";
    document.getElementById("mobileImgContainer").style.height = stickyModalSize + "px";
  } else {
    document.getElementById("leftMobileCustomImg").style.display = "none";
    document.getElementById("leftIconContainer").style.display = "none";
    document.getElementById("leftMagIcon").style.display = "none";
    document.getElementById("mobileCustomImg").style.display = "none";
    document.getElementById("iconContainer").style.display = "none";
    document.getElementById("magIcon").style.display = "none";
    document.getElementById("rightMobileCustomImg").style.display = "none";
    document.getElementById("rightIconContainer").style.display = "none";
    document.getElementById("rightMagIcon").style.display = "none";
    document.getElementById("mobileHeader").style.display = "none";
    document.getElementById("price").style.display = "none";
    document.getElementById("currency_message").style.display = "none";
    document.getElementById("mobileImgContainer").style.height = "0px";
  }

  var i;
  for (i = 0; i < $('.pattern-heading').length; i++) {
    var headingTop = Math.round($('.pattern-heading').eq(i).offset().top);

    if ($('.pattern-heading').eq(i).is(':visible')) {
      if (i + 1 < $('.pattern-heading').length) {
        var nextHeadingTop = Math.round($('.pattern-heading').eq(i + 1).offset().top);

        if (i == 0 && window_top < nextHeadingTop - stickyModalSize) {
          var headerText = $('.pattern-heading')[i].firstElementChild.innerText;
          var collapseText = headerText.trim().replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            if (collapseField.classList.contains('icon-down-arrow')) {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-down-arrow"></span></p>';
            } else {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-up-arrow"></span></p>';
            }
            document.getElementById('mobileHeader').dataset.section = collapseText;
          } else {
            document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link"></span></p>';
            document.getElementById('mobileHeader').dataset.section = collapseText;
          }
        } else if (window_top >= headingTop - stickyModalSize && (window_top < nextHeadingTop - stickyModalSize || !$('.pattern-heading').eq(i+1).is(':visible'))) {
          var headerText = $('.pattern-heading')[i].firstElementChild.innerText;
          var collapseText = headerText.trim().replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            if (collapseField.classList.contains('icon-down-arrow')) {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-down-arrow"></span></p>';
            } else {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-up-arrow"></span></p>';
            }
            document.getElementById('mobileHeader').dataset.section = collapseText;
          } else {
            document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link"></span></p>';
            document.getElementById('mobileHeader').dataset.section = collapseText;
          }
        }
      } else {
        if (window_top >= headingTop - stickyModalSize) {
          var headerText = $('.pattern-heading')[i].firstElementChild.innerText;
          var collapseText = headerText.trim().replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            if (collapseField.classList.contains('icon-down-arrow')) {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-down-arrow"></span></p>';
            } else {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-up-arrow"></span></p>';
            }
            document.getElementById('mobileHeader').dataset.section = collapseText;
          } else {
            document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link right"></span></p>';
            document.getElementById('mobileHeader').dataset.section = collapseText;
          }
        }
      }
    }
  }
}

function changeSection(button) {
  var stickyModalSize = 197.2;
  var window_top = Math.round($(window).scrollTop());
  var prevSection = -1;
  var nextSection = -1;

  // if (button == 'next') {
  //   gtag('event', 'previous-next', {'action': 'next' }); 
  // } else {
  //   gtag('event', 'previous-next', {'action': 'previous' }); 
  // }

  var i;
  for (i = 0; i < $('.pattern-heading').length; i++) {
    var headingTop = Math.round($('.pattern-heading').eq(i).offset().top);

    if ($('.pattern-heading').eq(i).is(':visible')) {
      if (i + 1 < $('.pattern-heading').length) {
        var nextHeadingTop;
        var j;
        for (j = i + 1; j < $('.pattern-heading').length; j++) {
          if ($('.pattern-heading').eq(j).is(':visible')) {
            nextHeadingTop = Math.round($('.pattern-heading').eq(j).offset().top);
            break;
          }
        }

        if (i == 0 && window_top < nextHeadingTop - stickyModalSize) {
          prevSection = -1;
          nextSection = -1;
        } else if (i == 1 && window_top > headingTop - stickyModalSize && window_top < nextHeadingTop - stickyModalSize) {
          prevSection = -1;
          for (j = i + 1; j < $('.pattern-heading').length; j++) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          nextSection = j;
        } else if (window_top >= headingTop - stickyModalSize && window_top < nextHeadingTop - stickyModalSize) {
          for (j = i - 1; j > 0; j--) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          prevSection = j;
          for (j = i + 1; j < $('.pattern-heading').length; j++) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          nextSection = j;
        }
      } else {
        if (window_top >= headingTop - stickyModalSize) {
          for (j = i - 1; j > 0; j--) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          prevSection = j;
          nextSection = -1;
        }
      }
    }
  }

  if (button == "previous" && prevSection != -1) {
    var offsetPosition = $('.pattern-heading').eq(prevSection).offset().top - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  } else if (button == "next" && nextSection != -1) {
    var offsetPosition = $('.pattern-heading').eq(nextSection).offset().top - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

function collapseSectionFromHeader() {
  var sectionName = document.getElementById('mobileHeader').dataset.section;
  collapseSection(sectionName);
}

function collapseSection(sectionName){
  var stickyModalSize = 197.2;
  var topField = document.getElementById("top-collapse-field");
  var mobileHeader = document.getElementById("mobileHeader");

  var collapseFieldName = sectionName.concat("-collapse-field");
  var collapseField = document.getElementById(collapseFieldName);

  var collapseName = sectionName.concat("-collapse");
  var collapse = document.getElementById(collapseName);

  if (collapseField.classList.contains("icon-up-arrow")) {
    // gtag('event', 'collapse-expand', {'action': 'collapse', 'label': sectionName }); 
    $(collapse).hide();
    collapseField.classList.remove('icon-up-arrow');
    collapseField.classList.add('icon-down-arrow');
    if (mobileHeader.innerText.toLowerCase() == collapseField.parentElement.innerText.toLowerCase()) {
      mobileHeader.firstElementChild.firstElementChild.classList.remove('icon-up-arrow');
      mobileHeader.firstElementChild.firstElementChild.classList.add('icon-down-arrow');
    }
    var collapseFieldNameId = "#".concat(collapseFieldName);
    var offsetPosition = $(collapseFieldNameId).offset().top + 39.2 - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "auto"
    });
  } else {
    // gtag('event', 'collapse-expand', {'action': 'expand', 'label': sectionName });
    $(collapse).show();
    collapseField.classList.remove('icon-down-arrow');
    collapseField.classList.add('icon-up-arrow');
    if (mobileHeader.innerText.toLowerCase() == collapseField.parentElement.innerText.toLowerCase()) {
      mobileHeader.firstElementChild.firstElementChild.classList.remove('icon-down-arrow');
      mobileHeader.firstElementChild.firstElementChild.classList.add('icon-up-arrow');
    }
  }
}

function verifySubmit(e) {
  e.preventDefault();

  var name = document.getElementById('name').value;
  var email = document.getElementById('email').value;
  if (name != "" && email != "") {
    grecaptcha.ready(function() {
      grecaptcha.execute('6LeLwI4kAAAAANWEbOpzGXY-pITFa6Qngo4OOiZp', {action: 'sumbitForm'}).then(function(token) {
        document.getElementById("token").value = token;
        document.getElementById("moreInfoForm").submit();
      });
    });
  } else {
    var missingFields = [];
    if (name == "") {
      missingFields.push("name");
    }
    if (email == "") {
      missingFields.push("email");
    }

    if (missingFields.length == 2) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(" ");
        }
      }
      alertMessage = alertMessage.concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 1) {
      var name = missingFields[0];
      document.getElementById(missingFields[0]).style.border = '#a71616 2px solid';
      var alertMessage = "Please provide your ".concat(name).concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    }
  }
}

function checkPriceBeforeSubmit(event) {
  var priceEstimate = document.getElementById('price_estimate').value;
  if (priceEstimate == "---") {
    document.getElementById('waiting_to_submit').value = 'true';
  } else {
    submitInvoice(event);
  }
}

function submitInvoice() {
  var metal = document.getElementById('metal').value;
  var karat = document.getElementById('karat').value;
  var weight = document.getElementById('weight').value;
  var shape = document.getElementById('shape').value;
  var finish = document.getElementById('finish').value;
  var secondFinish = document.getElementById('second_finish').value;
  var width = document.getElementById('width').value;
  var ringSize = document.getElementById('ring_size').value;
  var origin = document.getElementById('origin').value;
  var priceEstimate = document.getElementById('price_estimate').value;
  var salePriceEstimate = document.getElementById('sale_price_estimate').value;
  var priceWithoutAddOnsEstimate = document.getElementById('price_without_addons_estimate').value;
  var salePriceWithoutAddOnsEstimate = document.getElementById('sale_price_without_addons_estimate').value;
  var imageURL = document.getElementById('imageURL').value;
  var customInvoiceButton = document.getElementById('customInvoice');
  var cartButtonLoad = document.getElementById('cartButtonLoad');
  var cartButtonText = document.getElementById('cartButtonText');

  document.getElementById('cartButtonText').style.display = 'inline-block';
  document.getElementById('cartButtonLoad').style.display = 'none';

  if (ringSize != "") {
    grecaptcha.ready(function() {
      grecaptcha.execute('6LeLwI4kAAAAANWEbOpzGXY-pITFa6Qngo4OOiZp', {action: 'sumbitForm'}).then(function(token) {
        document.getElementById("token").value = token;
        
        customInvoiceButton.disabled = true;
        customInvoiceButton.style.backgroundColor = "#777";
        cartButtonText.style.display = "none";
        cartButtonLoad.style.display = "inline-block";
        showLoadingModal();
    
        $.ajax({
          type: "POST",
          url: "https://custom.stonebrookjewelry.com/revo/precious/product_submit.php",
          data: { metal: metal, karat: karat, weight: weight, shape: shape, finish: finish, second_finish: secondFinish, width: width, ring_size: ringSize, origin: origin, price_estimate: priceEstimate, sale_price_estimate: salePriceEstimate, price_without_addons_estimate: priceWithoutAddOnsEstimate, sale_price_without_addons_estimate: salePriceWithoutAddOnsEstimate, imageURL: imageURL, token: token },
          success: function(returnedData){
            // Do something on success
            customInvoiceButton.disabled = false;
            customInvoiceButton.style.backgroundColor = "#557373";
            cartButtonText.style.display = "inline";
            cartButtonLoad.style.display = "none";
    
            if (returnedData.success == "true") {
              const randNum = Math.floor(Math.random() * 1000000000);
              var items = "{\"items\":[";
              // Ring
              items = items + "{\"id\":" + returnedData.id + ",\"quantity\":1,\"properties\":{\"Ring Size\":\"" + ringSize + "\",\"_iid\":\"" + randNum + "\"}}";
              // Ring Sizers
              if (ringSize == "Send Ring Sizers") {
                const ringSizersId = 12840612102216;
                items = items + ",{\"id\":" + ringSizersId + ",\"quantity\":1,\"properties\":{\"Ring\":\"" + returnedData.title + "\",\"_iid\":\"" + randNum + "\"}}";
              }
              items = items + "]}";

              setTimeout(() => {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: items
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    window.location.href = '/cart';
                    return response.json();
                })
                .catch((error) => {
                  closeLoadingModal();
                  console.error('Error:', error);
                  document.getElementById('submitError').style.display = "block";
                  showRequestMoreModal();
                });
              }, 8000);
            } else {
              closeLoadingModal();
              document.getElementById('submitError').style.display = "block";
              showRequestMoreModal();
            }
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            // Do something on error
            customInvoiceButton.disabled = false;
            customInvoiceButton.style.backgroundColor = "#557373";
            cartButtonText.style.display = "inline";
            cartButtonLoad.style.display = "none";
            closeLoadingModal();

            document.getElementById('submitError').style.display = "block";
            showRequestMoreModal();
    
            console.log("XMLHttpRequest: ");
            console.log(XMLHttpRequest);
            console.log("textStatus: ");
            console.log(textStatus);
            console.log("errorThrown: ");
            console.log(errorThrown);
          }
        });
      });
    });
  } else {
    var missingFields = [];
    if (ringSize == "") {
      missingFields.push("ring_size");
    }

    if (missingFields.length == 4 || missingFields.length == 3) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        if (name == "ring_size") {
          name = "ring size";
        }
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(", ");
        }
      }
      alertMessage = alertMessage.concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 2) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        if (name == "ring_size") {
          name = "ring size";
        }
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(" ");
        }
      }
      alertMessage = alertMessage.concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 1) {
      var name = missingFields[0];
      if (name == "ring_size") {
        name = "ring size";
      }
      document.getElementById(missingFields[0]).style.border = '#a71616 2px solid';
      var alertMessage = "Please provide your ".concat(name).concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    }
  }
}

function checkEmpty(name) {
  if (document.getElementById(name).value != "") {
    document.getElementById(name).style.border = '1px solid #cccccc';
  }
}

$(function() {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});

function showRequestMoreModal() {
  event.preventDefault();
  document.getElementById('requestMoreModal').style.display = "block";
}

function showSuccessModal() {
  document.getElementById('successModal').style.display = "block";
}

function closeSuccessModalByButton() {
  event.preventDefault();
  document.getElementById('successModal').style.display = "none";
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function showLoadingModal() {
  document.getElementById('loadingModal').style.display = "block";
}

function closeLoadingModal() {
  document.getElementById('loadingModal').style.display = "none";
}

function goToCartButton() {
  event.preventDefault();
  window.location.href = '/cart/checkout';
}

function updateRecommendations() {
  var profiles = {"Domed": "D", "Flat": "F", "Beveled": "B-NS", "High Bevel": "HB", "Flat Grooved Edges": "FGE", "Concave Bevel": "CB", "Concave Center Round Edges": "REC", "Domed Bevel": "DB", "Domed Center Concave": "DC", "Domed Center Round": "DD", "Domed Milgrain Edges": "DMIL", "Domed Rounded Edges": "RED", "Domed Stepped Down Edges": "DGE", "Flat Double Stepped Edges": "F2S", "Flat Rounded Edges": "REF", "Flat Stepped Edges Milgrain": "FGEW2UMIL", "Flat Wide Grooved Edges": "FGEW", "High Bevel Milgrain": "HB2UMIL", "Stepped Bevel": "B-S", "Ultra Comfort": "UC", "Flat with Off Center Accent Groove": "F1.5OC", "Domed with Off Center Accent Groove": "D1.5OC", "Beveled with Center Accent Groove": "B11U", "Domed with Two Accent Grooves": "D2.5"};
  var widths = {"2mm": "2", "3mm": "3", "4mm": "4", "5mm": "5", "6mm": "6", "7mm": "7", "8mm": "8", "9mm": "9", "10mm": "10"};
  var ringMaterials = {"Titanium": "T", "Cobalt Chrome": "CC", "Inconel": "CC", "Black Titanium": "Z", "Black Zirconium": "Z", "Tantalum": "TA", "Darkened Tantalum": "NTA", "Damascus Steel": "D", "Zebra Damascus Steel": "D-ZEBRA", "Flattwist Damascus Steel": "D-FLATTWIST", "Basketweave Damascus Steel": "D-BASKETWEAVE", "Tiger Damascus Steel": "D-TIGER", "Kuro Damascus Steel": "D-WOODGRAIN", "Marble Damascus Steel": "D-MARBLE", "Sunset Damascus Steel": "D-SUNSET", "Tightweave Damascus Steel": "D-TIGHTWEAVE", "Kinetic Damascus Steel": "D-KINETIC", "Scale Damascus Steel": "D-SCALE", "10k Yellow Gold": "10KY", "14k Yellow Gold": "14KY", "18k Yellow Gold": "18KY", "22k Yellow Gold": "22KY", "10k White Gold": "10KW", "14k White Gold": "14KW", "18k White Gold": "18KW", "14k Rose Gold": "14KR", "18k Rose Gold": "18KR", "Palladium": "PALL", "Platinum": "PLAT", "Palladium Silver": "CC", "Kuro-Ti": "TD", "Superconductor": "SC", "Darkened Superconductor": "NSC", "Meteorite" : "MET", "Forged Carbon Fiber" : "FORGEDCF"};
  var ringWeights = {"Premium": "P", "Standard": "IS", "Light": "L"};
  var ringFinishes = {"None": "", "Polish": "POLISH", "Polish Damascus": "POLISH", "Polish Kuro Damascus": "POLISH", "Polish Kuro-Ti": "POLISH", "Satin": "SATIN", "Satin Etched Kuro-Ti": "SATINETCHED", "Angle Satin": "ANGLESATIN", "Cross Satin": "CROSSSATIN", "Cross Satin Black": "CROSSSATINBLACK", "Cross Satin Silver": "CROSSSATINSILVER", "Stone": "STONE", "Angle Stone": "ANGLESTONE", "Bead Blast": "BEAD", "Bead Blast Damascus": "BEAD", "Bead Blast Kuro Damascus": "BEAD", "Sand Blast": "SAND", "Hammer": "HAMMER", "Machine": "MACHINE", "Distressed": "DISTRESSED", "Treebark 1": "TREEBARK1", "Treebark 3": "TREEBARK3", "Treebark H": "TREEBARKH", "Rock": "ROCK", "Rock Polish": "ROCKPOLISH", "Stipple": "STIPPLE", "Acid": "ACID", "Acid Damascus": "ACID", "Tumble": "ACID", "Tumble Kuro Damascus": "ACID", "Polish Superconductor": "POLISH", "Satin Superconductor": "SATIN", "Bead Blast Superconductor": "BEAD", "Polish Etched Superconductor": "POLISHETCHED", "Satin Etched Superconductor": "SATINETCHED", "Bead Blast Etched Superconductor": "BEADETCHED"};
  
  var sleeves = ["Z", "TA", "SC", "NSC", "FORGEDCF", "ANTLER", "HW-ASIANIRONBURL", "HW-BLOODWOOD", "HW-BOCOTE", "HW-BOXELDERBURL", "HW-NATCOCO", "HW-DESERTIRONWOOD", "HW-EBONY", "HW-KOA", "HW-LEOPARD", "HW-MADAGASCARROSEWOOD", "HW-MAPLEBURL", "HW-NATURALOAK", "HW-OSAGEORANGE", "HW-PADAUK", "HW-PERNAMBUCO", "HW-PYINMABURL", "HW-REDHEART", "HW-SAPELE", "HW-SEQUOIA", "HW-SPALTEDTAMARIND", "HW-TEAK", "HW-THUYABURL", "HW-WALNUT", "HW-WENGE", "HW-WHISKEYBARREL", "HW-ZIRICOTE", "DAMASCUS", "ZEBRA", "FLATTWIST", "BASKETWEAVE", "TIGER", "WOODGRAIN", "TD", "SUNSET", "MARBLE", "TIGHTWEAVE", "KINETIC", "SCALE", "WMOP", "BMOP", "ABALONE"];
  
  var inlayTypes = ["NUGGET-GOLDNUGGET", "MOSAIC-BLACKONYX", "MOSAIC-BLACKTOURMALINE", "MOSAIC-BLUEAPATITE", "MOSAIC-BLUESAPPHIRE", "MOSAIC-BLUETIGEREYE", "MOSAIC-CHALCOPYRITE", "MOSAIC-CHAROITE", "MOSAIC-CHRYSOCOLLA", "MOSAIC-CORAL", "MOSAIC-DALMATIANJASPER", "MOSAIC-DESERTJASPER", "MOSAIC-GARNET", "MOSAIC-GOLDTIGEREYE", "MOSAIC-GREENFUSCHITE", "MOSAIC-LAPIS", "MOSAIC-LEPIDOLITE", "MOSAIC-MALACHITE", "MOSAIC-OCEANJASPER", "MOSAIC-REDTIGEREYE", "MOSAIC-SODALITE", "MOSAIC-THULITE", "MOSAIC-TURQUOISE", "MOSAIC-DINOSAURBONEBLACK", "MOSAIC-DINOSAURBONERED", "MOSAIC-DINOSAURBONETAN"];
  var inlayTypes3mm = ["NUGGET-GOLDNUGGET", "TANTALUM", "TANTALUMNOIR", "ZIRCONIUM", "DAMASCUS", "ZEBRA", "FLATTWIST", "BASKETWEAVE", "TIGER", "WOODGRAIN", "MARBLE", "SUNSET", "TIGHTWEAVE", "KINETIC", "SCALE", "C-FORGEDCF", "C-SILVERCF", "C-CF", "METEORITE", "HW-BLOODWOOD", "HW-BOCOTE", "HW-BOXELDERBURL", "HW-NATCOCO", "HW-DESERTIRONWOOD", "HW-EBONY", "HW-KOA", "HW-LEOPARD", "HW-MADAGASCARROSEWOOD", "HW-MAPLEBURL", "HW-NATURALOAK", "HW-OSAGEORANGE", "HW-PADAUK", "HW-PERNAMBUCO", "HW-PYINMABURL", "HW-REDHEART", "HW-SAPELE", "HW-SEQUOIA", "HW-SPALTEDTAMARIND", "HW-TEAK", "HW-THUYABURL", "HW-WALNUT", "HW-WENGE", "HW-WHISKEYBARREL", "HW-ZIRICOTE", "ANTLER", "MOSAIC-BLACKONYX", "MOSAIC-BLACKTOURMALINE", "MOSAIC-BLUEAPATITE", "MOSAIC-BLUESAPPHIRE", "MOSAIC-BLUETIGEREYE", "MOSAIC-CHALCOPYRITE", "MOSAIC-CHAROITE", "MOSAIC-CHRYSOCOLLA", "MOSAIC-CORAL", "MOSAIC-DALMATIANJASPER", "MOSAIC-DESERTJASPER", "MOSAIC-GARNET", "MOSAIC-GOLDTIGEREYE", "MOSAIC-GREENFUSCHITE", "MOSAIC-LAPIS", "MOSAIC-LEPIDOLITE", "MOSAIC-MALACHITE", "MOSAIC-OCEANJASPER", "MOSAIC-REDTIGEREYE", "MOSAIC-SODALITE", "MOSAIC-THULITE", "MOSAIC-TURQUOISE", "MOSAIC-DINOSAURBONEBLACK", "MOSAIC-DINOSAURBONERED", "MOSAIC-DINOSAURBONETAN", "WMOP", "BMOP", "ABALONE", "TITANIUMDAMASCUS", "SUPERCONDUCTOR", "SUPERCONDUCTORNOIR"];
  
  var gemstoneArrangements = ["3X", "5X", "9X", "ETERNITY", "HALFETERNITY"];
  var gemstoneColors = ["DIA", "LABDIA", "BLKDIA", "COCODIA", "AQUADIA", "GREENDIA", "YELLOWDIA", "SAPP", "DENIMSAPP", "PINKSAPP", "PINK2SAPP", "YELLOWSAPP", "RUBY", "DARKRUBY"];

  
  var inlayTypeNames = {"NUGGET-GOLDNUGGET": "24k Raw Gold Nugget", "TANTALUM": "Tantalum", "TANTALUMNOIR": "Darkened Tantalum", "ZIRCONIUM": "Black Titanium", "DAMASCUS": "Damascus Steel", "ZEBRA": "Zebra Damascus Steel", "FLATTWIST": "Flattwist Damascus Steel", "BASKETWEAVE": "Basketweave Damascus Steel", "TIGER": "Tiger Damascus Steel", "WOODGRAIN": "Kuro Damascus Steel", "MARBLE": "Marble Damascus Steel", "SUNSET": "Sunset Kuro Damascus Steel", "TIGHTWEAVE": "Tightweave Kuro Damascus Steel", "KINETIC": "Kinetic Kuro Damascus Steel", "SCALE": "Scale Kuro Damascus Steel", "C-FORGEDCF": "Forged Carbon Fiber", "C-SILVERCF": "Silver Texalium", "C-CF": "Black Carbon Fiber", "METEORITE": "Meteorite", "HW-BLOODWOOD": "Blood Wood", "HW-BOCOTE": "Bocote", "HW-BOXELDERBURL": "Boxelder Burl", "HW-NATCOCO": "Cocobolo", "HW-DESERTIRONWOOD": "Desert Iron Wood", "HW-EBONY": "Ebony", "HW-KOA": "Koa", "HW-LEOPARD": "Leopard Wood", "HW-MADAGASCARROSEWOOD": "Madagascar Rose Wood", "HW-MAPLEBURL": "Maple Bulr", "HW-NATURALOAK": "Natural Oak", "HW-OSAGEORANGE": "Osage Orange", "HW-PADAUK": "Padauk", "HW-PERNAMBUCO": "Pernambuco", "HW-PYINMABURL": "Pyinmaburl", "HW-REDHEART": "Red Heart", "HW-SAPELE": "Sapele", "HW-SEQUOIA": "Sequoia", "HW-SPALTEDTAMARIND": "Spalted Tamarind", "HW-TEAK": "Teak", "HW-THUYABURL": "Thuya Burl", "HW-WALNUT": "Walnut", "HW-WENGE": "Wenge", "HW-WHISKEYBARREL": "Whiskey Barrel", "HW-ZIRICOTE": "Zircote", "ANTLER": "Antler", "MOSAIC-BLACKONYX": "Black Onyx", "MOSAIC-BLACKTOURMALINE": "Black Tourmaline", "MOSAIC-BLUEAPATITE": "Blue Apatite", "MOSAIC-BLUESAPPHIRE": "Blue Sapphire", "MOSAIC-BLUETIGEREYE": "Blue Tigers Eye", "MOSAIC-CHALCOPYRITE": "Chalcopyrite", "MOSAIC-CHAROITE": "Charoite", "MOSAIC-CHRYSOCOLLA": "Chrysocolla", "MOSAIC-CORAL": "Coral", "MOSAIC-DALMATIANJASPER": "Dalmatian Jasper", "MOSAIC-DESERTJASPER": "Desert Jasper", "MOSAIC-GARNET": "Garnet", "MOSAIC-GOLDTIGEREYE": "Gold Tigers Eye", "MOSAIC-GREENFUSCHITE": "Green Fuschite", "MOSAIC-LAPIS": "Lapis", "MOSAIC-LEPIDOLITE": "Lepidolite", "MOSAIC-MALACHITE": "Malachite", "MOSAIC-OCEANJASPER": "Ocean Jasper", "MOSAIC-REDTIGEREYE": "Red Tigers Eye", "MOSAIC-SODALITE": "Sodalite", "MOSAIC-THULITE": "Thulite", "MOSAIC-TURQUOISE": "Turquoise", "MOSAIC-DINOSAURBONEBLACK": "Black Dinosaur Bone", "MOSAIC-DINOSAURBONERED": "Red Dinosaur Bone", "MOSAIC-DINOSAURBONETAN": "Tan Dinosaur Bone", "WMOP": "Freshwater Mother of Pearl", "BMOP": "Black Mother of Pearl", "ABALONE": "Abalone", "TITANIUMDAMASCUS": "Kuro-Ti", "SUPERCONDUCTOR": "Superconductor", "SUPERCONDUCTORNOIR": "Darkened Superconductor"};
  var gemstoneArrangementNames = {"3X": "3", "5X": "5", "9X": "9", "ETERNITY": "Eternity", "HALFETERNITY": "Half Eternity"};
  var gemstonePluralColorNames = {"DIA": "Diamonds", "LABDIA": "Lab Diamonds", "BLKDIA": "Black Diamonds", "COCODIA": "Coco Diamonds", "AQUADIA": "Aqua Diamonds", "GREENDIA": "Green Diamonds", "YELLOWDIA": "Yellow Diamonds", "SAPP": "Sapphires", "DENIMSAPP": "Denim Sapphires", "PINKSAPP": "Pink Sapphires", "PINK2SAPP": "Dark Pink Sapphires", "YELLOWSAPP": "Yellow Sapphires", "RUBY": "Rubies", "DARKRUBY": "Dark Rubies"};
  var gemstoneColorNames = {"DIA": "Diamond", "LABDIA": "Lab Diamond", "BLKDIA": "Black Diamond", "COCODIA": "Coco Diamond", "AQUADIA": "Aqua Diamond", "GREENDIA": "Green Diamond", "YELLOWDIA": "Yellow Diamond", "SAPP": "Sapphire", "DENIMSAPP": "Denim Sapphire", "PINKSAPP": "Pink Sapphire", "PINK2SAPP": "Dark Pink Sapphire", "YELLOWSAPP": "Yellow Sapphire", "RUBY": "Ruby", "DARKRUBY": "Dark Ruby"};
  var sleeveNames = {"Z": "Black Titanium", "TA": "Tantalum", "SC": "Superconductor", "NSC": "Darkened Superconductor", "FORGEDCF": "Forged Carbon Fiber", "ANTLER": "Antler", "HW-BLOODWOOD": "Blood Wood", "HW-BOCOTE": "Bocote", "HW-BOXELDERBURL": "Boxelder Burl", "HW-NATCOCO": "Cocobolo", "HW-DESERTIRONWOOD": "Desert Iron Wood", "HW-EBONY": "Ebony", "HW-KOA": "Koa", "HW-LEOPARD": "Leopard Wood", "HW-MADAGASCARROSEWOOD": "Madagascar Rose Wood", "HW-MAPLEBURL": "Maple Burl", "HW-NATURALOAK": "Natural Oak", "HW-OSAGEORANGE": "Osage Orange", "HW-PADAUK": "Padauk", "HW-PERNAMBUCO": "Pernambuco", "HW-PYINMABURL": "Pyinmaburl", "HW-REDHEART": "Red Heart", "HW-SAPELE": "Sapele", "HW-SEQUOIA": "Sequoia", "HW-SPALTEDTAMARIND": "Spalted Tamarind", "HW-TEAK": "Teak", "HW-THUYABURL": "Thuyaburl", "HW-WALNUT": "Walnut", "HW-WENGE": "Wenge", "HW-WHISKEYBARREL": "Whiskey Barrel", "HW-ZIRICOTE": "Ziricote", "DAMASCUS": "Damascus Steel", "ZEBRA": "Zebra Damascus Steel", "FLATTWIST": "Flattwist Damascus Steel", "BASKETWEAVE": "Basketweave Damascus Steel", "TIGER": "Tiger Damascus Steel", "WOODGRAIN": "Kuro Damascus Steel", "TD": "Kuro-Ti", "SUNSET": "Sunset Kuro Damascus Steel", "MARBLE": "Marble Kuro Damascus Steel", "TIGHTWEAVE": "Tightweave Kuro Damascus Steel", "KINETIC": "Kinetic Kuro Damascus Steel", "SCALE": "Scale Kuro Damascus Steel", "WMOP": "Freshwater Mother of Pearl", "BMOP": "Black Mother of Pearl", "ABALONE": "Abalone"};
  
  var materialInput = document.getElementById("karat");
  var material = ringMaterials[materialInput.value];
  var shapeInput = document.getElementById("shape");
  var shape = profiles[shapeInput.value];
  var weightInput = document.getElementById("weight");
  var weight = ringWeights[weightInput.value];
  var finishInput = document.getElementById("finish");
  var finish = ringFinishes[finishInput.value];
  var secondFinishInput = document.getElementById("second_finish");
  var secondFinish = ringFinishes[secondFinishInput.value];
  var widthInput = document.getElementById("width");
  var width = widths[widthInput.value];

  var recommend1 = document.getElementById('recommend1');
  var recommend2 = document.getElementById('recommend2');
  var recommend3 = document.getElementById('recommend3');
  var recommend4 = document.getElementById('recommend4');
  var recommend1Label = document.getElementById('recommend1Label');
  var recommend2Label = document.getElementById('recommend2Label');
  var recommend3Label = document.getElementById('recommend3Label');
  var recommend4Label = document.getElementById('recommend4Label');
  var recommend1Link = document.getElementById('recommend1Link');
  var recommend2Link = document.getElementById('recommend2Link');
  var recommend3Link = document.getElementById('recommend3Link');
  var recommend4Link = document.getElementById('recommend4Link');

  var sleeve = sleeves[Math.floor(Math.random()*sleeves.length)];
  var sleeve2 = sleeves[Math.floor(Math.random()*sleeves.length)];
  var inlayMaterial = inlayTypes[Math.floor(Math.random()*inlayTypes.length)];
  var gemstoneArrangement = gemstoneArrangements[Math.floor(Math.random()*gemstoneArrangements.length)];
  var gemstoneColor = gemstoneColors[Math.floor(Math.random()*gemstoneColors.length)];
  var inlayMaterial3mm = inlayTypes3mm[Math.floor(Math.random()*inlayTypes3mm.length)];

  var pfInlayMaterials = ["TANTALUM", "TANTALUMNOIR", "ZIRCONIUM", "SUPERCONDUCTOR", "SUPERCONDUCTORNOIR", "DAMASCUS", "ZEBRA", "FLATTWIST", "BASKETWEAVE", "TIGER", "WOODGRAIN", "MARBLE", "SUNSET", "TIGHTWEAVE", "KINETIC", "SCALE", "TITANIUMDAMASCUS"];
  var damascusTypes = ["DAMASCUS", "ZEBRA", "FLATTWIST", "BASKETWEAVE", "TIGER", "WOODGRAIN", "MARBLE", "SUNSET", "TIGHTWEAVE", "KINETIC", "SCALE"];
  
  // Ensure recommendation have the required minimum width
  if (shapeInput.value == "Domed" || shapeInput.value == "Flat") {
    if (width == "2" || width == "3") {
      width = "4";
    }
  }

  if (shapeInput.value == "Domed Milgrain Edges" || shapeInput.value == "Beveled") {
    if (width == "2" || width == "3" || width == "4") {
      width = "5";
    }
  }

  if (shapeInput.value == "Domed Rounded Edges" || shapeInput.value == "Domed Stepped Down Edges" || shapeInput.value == "High Bevel" || shapeInput.value == "Flat Grooved Edges" || shapeInput.value == "High Bevel Milgrain" || shapeInput.value == "Stepped Bevel" || shapeInput.value == "Concave Bevel") {
    if (width == "2" || width == "3" || width == "4" || width == "5") {
      width = "6";
    }
  }

  if (shapeInput.value == "Flat Rounded Edges" || shapeInput.value == "Flat Stepped Edges Milgrain" || shapeInput.value == "Flat Wide Grooved Edges" || shapeInput.value == "Flat Double Stepped Edges") {
    if (width == "2" || width == "3" || width == "4" || width == "5" || width == "6") {
      width = "7";
    }
  }

  // Adjust shape to work for recommendations
  if (shapeInput.value == "Domed Center Round" || shapeInput.value == "Domed with Off Center Accent Groove" || shapeInput.value == "Domed with Two Accent Grooves" || shapeInput.value == "Ultra Comfort") {
    shape = "D";
  }

  if (shapeInput.value == "Flat with Off Center Accent Groove" || shapeInput.value == "Beveled with Center Accent Groove") {
    shape = "F";
  }

  // var src = "/rings/profiles/";
  var src = "https://assets.lashbrookdesigns.com/rings/profiles/";
  // var src = "https://api.lashbrookdesigns.com/api/v1";
  src = src.concat(shape);
  src = src.concat("/widths/");
  src = src.concat(width);
  src = src.concat("/ring_materials/");
  src = src.concat(material);
  src = src.concat("/images/1");
  src = src.concat("?ring_finish=");
  if (shape == "DD" || shape == "DC" || shape == "REC" || shape == "REF") {
    src = src.concat("POLISH%2C").concat(finish);
  } else if (shape == "RED") {
    src = src.concat(finish).concat("%2CPOLISH");
  } else if (shape == "B11U") {
    src = src.concat("POLISH%2C").concat(finish).concat('%2C').concat(secondFinish);
  } else if (shape == "CB" || shape == "B" || shape == "F1.5OC" || shape == "D1.5OC" || shape == "D2.5" || shape == "HB" || shape == "FGE" || shape == "DB" || shape == "DGE" || shape == "FGEW2UMIL" || shape == "FGEW" || shape == "HB2UMIL" || shape == "B-S" || shape == "F2S") {
    src = src.concat(finish).concat("%2C").concat(secondFinish);
  } else {
    src = src.concat(finish);
  }
  src = src.concat("&finish_type=FS");
  // src = src.concat("&weight=");
  // src = src.concat(weight);

  var ringSize = document.getElementById("ring_size").value;
  src = src.concat("&size=");
  if (ringSize != null && ringSize != 'Send Ring Sizers') {
    src = src.concat(ringSize);
  } else {
    src = src.concat("10");
  }
  src = src.concat("&feature_group=N");

  src = src.concat("&watermark=false");
  
  var weightString = "&weight".concat(weight);

  var firstRecommendSrc = src.concat("&sleeve=").concat(sleeve);
  firstRecommendSrc = firstRecommendSrc.replace(weightString, '');
  recommend1.src = firstRecommendSrc;

  recommend1Label.innerText = "Add ".concat(sleeveNames[sleeve]).concat(" Sleeve");

  recommend1Url = "/pages/custom-ring-design-tool?material=".concat(materialInput.value).concat("&shape=").concat(shapeInput.value).concat("&finish=").concat(finishInput.value).concat("&width=").concat(widthInput.value).concat("&sleeve_material=").concat(sleeveNames[sleeve]);
  recommend1Link.href = recommend1Url;

  var secondRecommenSrc = src.concat("&groove_group=11-n&grooves=11-N_").concat(inlayMaterial);
  secondRecommenSrc = secondRecommenSrc.replace(weightString, '');
  secondRecommenSrc = secondRecommenSrc.replace("feature_group=N", "feature_group=G");
  recommend2.src = secondRecommenSrc;

  recommend2Label.innerText = "Add ".concat(inlayTypeNames[inlayMaterial]).concat(" Inlay");

  recommend2Url = "/pages/custom-ring-design-tool?material=".concat(materialInput.value).concat("&shape=").concat(shapeInput.value).concat("&finish=").concat(finishInput.value).concat("&width=").concat(widthInput.value).concat("&outside_feature=Inlay&Inlay_location=Centered&inlay_width=One%201mm%20Centered&inlay_material=").concat(inlayTypeNames[inlayMaterial]);
  recommend2Link.href = recommend2Url;

  if (shapeInput == "Concave Bevel" || shapeInput == "Concave Center Round Edges") {
    thirdRecommenSrc = thirdRecommenSrc.replace(weightString, '');
    recommend3.src = thirdRecommenSrc;
  
    recommend3Label.innerText = "Add ".concat(sleeveNames[sleeve2]).concat(" Sleeve");
  
    recommend3Url = "/pages/custom-ring-design-tool?material=".concat(materialInput.value).concat("&shape=").concat(shapeInput.value).concat("&finish=").concat(finishInput.value).concat("&width=").concat(widthInput.value).concat("&sleeve_material=").concat(sleeveNames[sleeve2]);
    recommend3Link.href = recommend3Url;
  } else {
    var gemstoneSettingStyle = "";
    var thirdRecommenSrc = src.concat("&gemstones=").concat(gemstoneArrangement).concat("-N_ROUND_").concat(gemstoneColor).concat("_.03_");
    if (gemstoneArrangement == "9X" || gemstoneArrangement == "HALFETERNITY" || gemstoneArrangement == "ETERNITY") {
      thirdRecommenSrc = thirdRecommenSrc.concat("CH");
      gemstoneSettingStyle = "Channel";
    } else {
      thirdRecommenSrc = thirdRecommenSrc.concat("B-SS");
      gemstoneSettingStyle = "Bezel";
    }
    thirdRecommenSrc = thirdRecommenSrc.replace(weightString, '');
    thirdRecommenSrc = thirdRecommenSrc.replace("feature_group=N", "feature_group=D");
    recommend3.src = thirdRecommenSrc;
  
    recommend3Label.innerText = "Add ".concat(gemstonePluralColorNames[gemstoneColor]);
    
    recommend3Url = "/pages/custom-ring-design-tool?material=".concat(materialInput.value).concat("&shape=").concat(shapeInput.value).concat("&finish=").concat(finishInput.value).concat("&width=").concat(widthInput.value).concat("&outside_feature=Gemstone&gemstone_arrangement=").concat(gemstoneArrangementNames[gemstoneArrangement]).concat("&gemstone_color=").concat(gemstoneColorNames[gemstoneColor.replace("s","")]).concat("&gemstone_shape=Round&gemstone_size=.03%20carat&gemstone_setting_style=").concat(gemstoneSettingStyle);
    recommend3Link.href = recommend3Url;
  }

  var fourthRecommenSrc = src.concat("&groove_group=13-n&grooves=13-N_").concat(inlayMaterial3mm);
  if (pfInlayMaterials.includes(inlayMaterial3mm)) {
    if (damascusTypes.includes(inlayMaterial3mm)) {
      fourthRecommenSrc = fourthRecommenSrc.concat("_ACID");
    } else {
      fourthRecommenSrc = fourthRecommenSrc.concat("_POLISH");
    }
  }
  fourthRecommenSrc = fourthRecommenSrc.replace(weightString, '');
  fourthRecommenSrc = fourthRecommenSrc.replace("feature_group=N", "feature_group=G");
  
  if (pfInlayMaterials.includes(inlayMaterial3mm)) {
    fourthRecommenSrc = fourthRecommenSrc.replace(material, "PF".concat(material));
  }
  recommend4.src = fourthRecommenSrc;

  recommend4Label.innerText = "Add ".concat(inlayTypeNames[inlayMaterial3mm]).concat(" Inlay");
  
  recommend4Url = "/pages/custom-ring-design-tool?material=".concat(materialInput.value).concat("&shape=").concat(shapeInput.value).concat("&finish=").concat(finishInput.value).concat("&width=").concat(widthInput.value).concat("&outside_feature=Inlay&Inlay_location=Centered&inlay_width=One%203mm%20Centered&inlay_material=").concat(inlayTypeNames[inlayMaterial3mm]);
  recommend4Link.href = recommend4Url;
}